import * as React from 'react';
import { observer, inject } from "mobx-react";
import { Button } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import StarOutlineIcon from '@material-ui/icons/StarOutline';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import InfiniteScroll from 'react-infinite-scroll-component';

// =====================================
// CONSTS
import { Messages } from '../../const/Messages';

// =====================================
// STORES
import { IArticleStore } from '../../store/ArticleStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { SearchHeader } from '../Layout/SearchHeader';
import { Loader } from '../Layout/Loader';

@inject((allStores: any) => ({
    articleStore: allStores.store.articleStore as IArticleStore
}))

@observer
export default class OrderingArticles extends React.Component<{ articleStore?: IArticleStore; customerId?: any; isEditOrder?: any; orderId?: any; }, any> {
    render() {

        let headerComponent: any = null;
        let backUrl = this.props.isEditOrder === "true" ? `/editorder/${this.props.customerId}/${this.props.orderId}` : `/neworder/${this.props.customerId}`;
        if (!this.props.articleStore.isSearchHeaderVisible) {
            headerComponent =
                <Header
                    title='Artikli za poručivanje'
                    isBackButtonVisible={true}
                    url={backUrl}
                    isSearchButtonVisible={true}
                    searchAction={this.props.articleStore.showSearchHeader} />
        } else {
            headerComponent =
                <SearchHeader
                    samePageAction={this.props.articleStore.hideSearchHeader}
                    clearAction={this.props.articleStore.clearArticleSearch}
                    keyword={this.props.articleStore.keyword}
                    onHandleSearch={this.props.articleStore.handleArticleSearch} />
        }

        return (
            <div>
                {headerComponent}

                <div className="container">
                    {!this.props.articleStore.isLoading ?
                        <div>
                            {!this.props.articleStore.isSearchEmpty ?
                                <div>
                                    {/* <InfiniteScroll
                                        dataLength={this.props.articleStore.articles.length}
                                        next={this.props.articleStore.fetchMoreArticles}
                                        hasMore={this.props.articleStore.hasMoreArticlesToLoad}
                                        endMessage={<div className="infinitescroll_msg">Svi artikli su učitani.</div>}
                                        loader={<div className="infinitescroll_msg">Učitavamo podatke...</div>}>
                                        <div> */}
                                    {this.props.articleStore.articles.map((article, i) => {
                                        return <div className="article" key={i}>
                                            <div>
                                                <div className="article-row">{article.code}</div>
                                                <div>{article.name}</div>
                                            </div>
                                            <div>
                                                {this.props.articleStore.favorites.filter(item => item.id === article.id).length > 0 ?
                                                    <StarIcon
                                                        className="star-icon"
                                                        onClick={() => { this.props.articleStore.addToFavorites(article) }} />
                                                    :
                                                    <StarOutlineIcon
                                                        className="star-icon"
                                                        onClick={() => { this.props.articleStore.addToFavorites(article) }} />
                                                }
                                            </div>
                                        </div>
                                    })}
                                    {/* </div>
                                    </InfiniteScroll> */}
                                </div>
                                : <div className="no_data">{Messages.ARTICLES_SEARCH_EMPTY + this.props.articleStore.keyword}</div>}

                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="save-btn"
                                onClick={this.props.articleStore.goToArticleDetails}
                                endIcon={<ArrowForwardIcon />}
                            >Dalje
                            </Button>
                        </div> : <Loader />}
                </div>
            </div>
        );
    }
}